// extracted by mini-css-extract-plugin
export default {"boxUrl":"PopupApiContent_boxUrl__srOkh","label":"PopupApiContent_label__UfJ5T","body":"PopupApiContent_body__5tUvr","btnsBody":"PopupApiContent_btnsBody__PZQsv"};